import { useRecordContext, useGetList, TextField } from "react-admin";
import { orgsFields } from "../../../organizations/orgs.model";
import { INSURANCE_PLANS_RESOURCE_NAME as INSURANCE_PLANS_RESOURCE } from "../../../insurancePlans/insurance.plans.dataProvider";
import { Typography } from "@mui/material";
import EmptyField from "../../../material/emptyField.component";

const InsurancePlanField = () => {
    const record = useRecordContext();
    const insuranceId = record[orgsFields.healthieInsuranceId];
    const { data } = useGetList(
        INSURANCE_PLANS_RESOURCE,
        { limit: 100 }
    );

    if (!data) {
        return null;
    }

    const insurancePlan = data.find(plan => Number(plan.id) === Number(insuranceId));

    if (!insurancePlan) {
        return <EmptyField />;
    }

    return (
        <Typography variant="body2">{insurancePlan.name_and_id}</Typography>
    )
}

export default InsurancePlanField;